import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getPartner, isDiscountProgram } from '../../../../utils/getter';
import { isAdmin } from '../../../../utils/helper';
import Navigation from '../../../../utils/navigation';

interface PartnerLogoProps {
  partner?: string;
  className?: string;
  // secondarylogo is used to hide/show adac logo(loyalty type
  secondaryLogo?: boolean;
  'data-testid'?: string;
}

const PartnerLogo: React.FC<PartnerLogoProps> = ({
  partner,
  secondaryLogo = true,
  className,
  'data-testid': testId = 'logo',
}) => {
  // Get partner logo
  const currantPartner = partner || getPartner();
  // Navigation
  const { nextRoute } = new Navigation();

  // Navigate Hook
  const navigate = useNavigate();

  //for smart
  const logoSrc =
    isDiscountProgram() && secondaryLogo
      ? `/theme/${currantPartner}/logo_discount.svg`
      : `/theme/${currantPartner}/logo.svg`;

  return (
    <img
      style={{ float: 'left' }}
      className={`logo ${className || ''}`}
      data-testid={testId}
      src={logoSrc}
      alt={`${currantPartner} leasing logo`}
      key='leasing-logo-image'
      onClick={() => {
        if (isAdmin()) {
          navigate(nextRoute());
        }
      }}
    />
  );
};

export default PartnerLogo;
